module.exports = __webpack_public_path__ + "static/media/brand-story-women.c7111fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/brand-stories/img/brand-story-women.png
// module id = 1711
// module chunks = 146